import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { fetchSharedChecklist } from "@/lib/api";
import Seo from "@/components/Seo";
import { ListChecks, Check, ArrowRight } from "lucide-react";

export default function SharedChecklist() {
  const { shareId } = useParams();
  const { pick } = useLang();
  const [cl, setCl] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    fetchSharedChecklist(shareId).then(setCl).catch(() => setNotFound(true));
  }, [shareId]);

  if (notFound) return <div className="mx-auto max-w-2xl px-5 py-32 text-center text-ink-3">{pick("यह साझा सूची अब उपलब्ध नहीं है।", "This shared checklist is no longer available.")}</div>;
  if (!cl) return <div className="mx-auto max-w-2xl px-5 py-32 text-center text-ink-3">…</div>;

  const done = cl.items.filter((i) => i.checked).length;

  return (
    <div data-testid="shared-checklist-page">
      <Seo path={`/checklist/${shareId}`} title={cl.title} description="A shared pooja preparation checklist from Dharmartha." noindex />
      <section className="mx-auto max-w-2xl px-5 py-16 md:px-8">
        <div className="mb-6 flex items-center gap-3">
          <ListChecks className="h-7 w-7 text-saffron" />
          <div>
            <p className="overline-label text-saffron">{cl.shared_by ? pick(`${cl.shared_by} द्वारा साझा`, `Shared by ${cl.shared_by}`) : pick("साझा पूजा सूची", "Shared pooja checklist")}</p>
            <h1 className="font-serif-latin text-3xl text-ink">{cl.title}</h1>
          </div>
        </div>

        <div className="rounded-xl border border-[var(--gold)]/25 bg-surface p-6">
          <p className="mb-4 text-xs text-ink-3">{done}/{cl.items.length} {pick("तैयार", "ready")}</p>
          <ul className="space-y-2.5">
            {cl.items.map((it, i) => (
              <li key={i} className="flex items-center gap-3" data-testid={`shared-item-${i}`}>
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded border ${it.checked ? "border-saffron bg-[var(--saffron)] text-white" : "border-line"}`}>{it.checked && <Check className="h-3.5 w-3.5" />}</span>
                <span className={`text-sm ${it.checked ? "text-ink-3 line-through" : "text-ink-2"}`}>{it.text}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-8 rounded-xl border border-line bg-parchment p-6 text-center">
          <p className="text-ink-2">{pick("अपनी स्वयं की पूजा तैयारी सूची बनाएँ एवं सहेजें।", "Make and save your own pooja preparation checklists.")}</p>
          <Link to="/checklists" data-testid="shared-cta" className="mt-4 inline-flex items-center gap-2 bg-[var(--saffron)] px-5 py-2.5 text-sm font-medium text-white transition-transform hover:-translate-y-0.5">
            {pick("मेरी सूचियाँ बनाएँ", "Create your own")} <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      </section>
    </div>
  );
}
